<template>
  <div class="cities">
    <SidebarLayout2
      :breadcrumb="breadcrumb"
      :rootPath="rootPath"
      :pageTitle="pageTitle"
    >
      <!-- BARRA LATERAL -->
      <template #sidebar>
        <!-- AÇÕES DA PÁGINA -->
        <SidebarBlock class="page-actions">
          <Heading>Ações da página</Heading>
          <!-- CADASTRAR -->
          <Button
            :hasIcon="true"
            :link="'/cidades/criar'"
            element="router-link"
            class="page-actions--button"
          >
            Cadastrar cidade
          </Button>
          <!-- EDITAR CIDADE -->
          <Button
            :disabled="selectedCities.length != 1"
            :link="
              `/cidades/editar/${
                selectedCities[0] ? selectedCities[0].codigo : null
              }`
            "
            element="router-link"
            class="page-actions--button"
          >
            Editar
          </Button>
          <!-- EXCLUIR -->
          <Button
            :disabled="selectedCities.length == 0"
            variation="error"
            class="page-actions--button"
            @click="showAlertModal = true"
          >
            Excluir
          </Button>
        </SidebarBlock>
        <!-- DICAS -->
        <SidebarBlock class="tips">
          <Heading>
            Dica
          </Heading>
          <Paragraph>
            Não encontrou a cidade desejada na lista? Para adicionar novas
            cidades, entre em contato com nosso suporte
            <a class="link" href="mailto:suporteplataformas@pmweb.com.br"
              >clicando aqui</a
            >.
          </Paragraph>
        </SidebarBlock>
      </template>
      <!-- CONTEÚDO -->
      <template #content>
        <SearchInput
          v-model="searchTerm"
          class="search-term"
          @input="searchData"
        />
        <FilterDropdown
          v-model="acronym"
          :options="acronymList"
          :hasSearch="true"
          :toggleAll="true"
          :radioOptions="false"
          toggleAllLabel="Todas"
          checkboxNoSelectionLabel="Todas"
          label="Sigla"
          searchFieldPlaceholder="Pesquisar siglas"
          class="filter-acronym"
          @input="searchData"
        />
        <DataTable
          :cols="gridColumns"
          :rows="gridData"
          :selectableRow="true"
          :isLoading="isLoadingTableContent"
          :colsMinWidths="colsWidths"
          class="datatable"
          ref="datatable"
          notFoundMessage="Não há cidades com a busca."
          @getSelectedRows="manageSelectedCities"
        >
          <template v-slot:editar="slotProps">
            <router-link
              class="links links--edit"
              :to="`/cidades/editar/${slotProps.rowDataObj.codigo}`"
            >
              Editar
            </router-link>
          </template>
          <template v-slot:excluir="slotProps">
            <span
              class="links links--delete"
              @click.stop.prevent="inativeCity(slotProps.rowDataObj.codigo)"
            >
              Excluir
            </span>
          </template>
        </DataTable>
      </template>
    </SidebarLayout2>
    <!-- MODAL DE EXCLUSÃO DE CIDADE -->
    <AlertModal
      v-model="showAlertModal"
      title="Excluir cidade"
      icon="trash-can"
      cancelButtonText="Cancelar"
      @alert-modal-confirm="inativeCities"
      @alert-modal-cancel="cancelInativeCities"
    >
      <template #text>
        Ao excluir essa cidade, ela não poderá<br />
        ser mais vinculada aos hotéis. <br />
        Tem certeza de que quer fazer isso?
      </template>
    </AlertModal>
    <!-- MODAL DE ALERTA DE EXCLUSÃO DE CIDADE -->
    <AlertModal
      v-model="showAlertModalCityCantDelete"
      title="Atenção"
      confirmButtonText="Ok, entendi"
      cancelButtonText="Cancelar"
      @alert-modal-confirm="showAlertModalCityCantDelete = false"
      @alert-modal-cancel="showAlertModalCityCantDelete = false"
    >
      <template #text>
        Não foi possível excluir, pois existem hotéis <br />
        vinculados a essa cidade. Para realizar a exclusão, <br />
        é necessário desvincular a cidade. É possível <br />
        buscar e encontrar quais hotéis estão vinculados a ela
        <button class="link" @click="toHotels()">clicando aqui</button>.
      </template>
    </AlertModal>
  </div>
</template>

<script>
import SidebarLayout2 from '@/layouts/SidebarLayout2'
import SearchInput from '@solucoes/components-lib-tmp/src/components/elements/SearchInput'
import DataTable from '@solucoes/components-lib-tmp/src/components/patterns/DataTable'
import FilterDropdown from '@solucoes/components-lib-tmp/src/components/patterns/FilterDropdown'
import SidebarBlock from '@solucoes/components-lib-tmp/src/components/patterns/SidebarBlock'
import Heading from '@solucoes/components-lib-tmp/src/components/elements/Heading'
import Button from '@solucoes/components-lib-tmp/src/components/elements/Button'
import AlertModal from '@solucoes/components-lib-tmp/src/components/patterns/AlertModal'
import Paragraph from '@solucoes/components-lib-tmp/src/components/elements/Paragraph'

export default {
  name: 'Cities',
  components: {
    SidebarLayout2,
    SearchInput,
    DataTable,
    SidebarBlock,
    Heading,
    Button,
    AlertModal,
    FilterDropdown,
    Paragraph
  },
  data() {
    return {
      rootPath: {
        /** ponto de partida do breadcrumb  */
        label: 'Home',
        url: 'relatorio-conversao',
        isSpa: false /** se deve ser um link para o site novo ou antigo */
      },
      breadcrumb: [
        {
          label: 'Site Letsbook',
          isSpa: false /** se deve ser um link para o site novo ou antigo  */
        },
        {
          label: 'Cidades',
          url: '/cidades',
          isSpa: true /** se deve ser um link para o site novo ou antigo  */
        }
      ],
      pageTitle: 'Cidades',
      searchTerm: null,
      /** colunas da tabela */
      gridColumns: [
        { name: 'cidade', alias: 'Cidade' },
        { name: 'sigla', alias: 'Sigla' },
        { name: 'estado', alias: 'Estado' },
        { name: 'pais', alias: 'País' },
        { name: 'editar', alias: 'Ações' },
        { name: 'excluir' }
      ],
      /** linhas da tabela */
      gridData: [],
      /** Larguras das colunas */
      colsWidths: {
        sigla: '70px',
        editar: '76px',
        excluir: '76px'
      },
      /** Filtro por sigla */
      acronym: [],
      /** Opções de siglas para filtrar */
      acronymList: [],
      /** cidades */
      cities: [],
      isLoadingTableContent: true,
      /** Cidades selecionadas */
      selectedCities: [],
      /** Código da cidade selecionada */
      selectedCity: null,
      /** Mostrar modal de exclusão */
      showAlertModal: false,
      /** Mostar modal de alerta caso a cidade não possa ser excluída */
      showAlertModalCityCantDelete: false
    }
  },
  created() {
    this.getCities()
  },
  methods: {
    /** Buscar cidades */
    getCities() {
      this.$cities
        .get()
        .then((response) => {
          /** Remover itens excluídos e ordenar pelo nome */
          let data = response.data.sort((a, b) =>
            a.nome > b.nome ? 1 : b.nome > a.nome ? -1 : 0
          )
          /** Formatar dados para a tabela */
          data = data.map((item) => {
            const obj = {
              data: {
                codigo: item.codigo,
                cidade: item.nome,
                sigla: item.sigla,
                estado: item.estado,
                pais: item.pais
              }
            }
            return obj
          })
          this.cities = data
          this.gridData = data
          this.isLoadingTableContent = false
          this.makeAcronymList()
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Houve um erro ao apresentar a listagem de cidades.'
          })
        })
    },
    /** Selecionar as cidades */
    manageSelectedCities(values) {
      this.selectedCities = values
    },
    /** Pesquisa das cidades */
    searchData() {
      /** Pesquisa pelo nome da cidade */
      const nameSearch = this.searchTerm ? this.searchTerm.toLowerCase() : false
      /** Pesquisa pela sigla da cidade */
      const acronymSearch = this.acronym.map((item) => item.value)

      this.gridData = this.cities.filter(function(item) {
        /** Verificar se o nome é igual ao termo pesquisado */
        const searchName =
          !nameSearch || item.data.cidade.toLowerCase().includes(nameSearch)
            ? true
            : false
        /** Verificar se a sigla é igual à sigla filtrada */
        const searchAcronym =
          acronymSearch.length === 0 || acronymSearch.includes(item.data.sigla)
            ? true
            : false
        return searchName && searchAcronym
      })
    },
    /** Inativar cidade (botão da tabela) */
    inativeCity(id) {
      this.selectedCity = id
      this.showAlertModal = true
    },
    /** Inativar cidades */
    inativeCities() {
      let cities = []
      if (this.selectedCity === null) {
        cities = this.selectedCities.map((a) => a.codigo)
      } else {
        cities = [this.selectedCity]
      }
      this.$cities
        .inative(cities)
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Cidade(s) excluída(s) com sucesso.'
          })
        })
        .catch(() => {
          this.showAlertModalCityCantDelete = true
        })
        .finally(() => {
          /** Resetar tabela */
          this.resetCities()
        })
    },
    /** Cancelar inativação dos grupos de usuarios */
    cancelInativeCities() {
      this.showAlertModal = false
      this.selectedCity = null
    },
    /** Resetar os dados da tabela */
    resetCities() {
      this.showAlertModal = false
      this.selectedCity = null
      this.selectedCities = []
      this.getCities()
    },
    /** Redirecionar para a tela de hotéis */
    toHotels() {
      this.$router.push({
        path: '/hoteis'
      })
    },
    /** Opções de filtro para siglas */
    makeAcronymList() {
      for (let i = 0; i < this.cities.length; i++) {
        if (!this.acronymList.includes(this.cities[i].data.sigla))
          this.acronymList.push({
            value: this.cities[i].data.sigla,
            label: this.cities[i].data.sigla
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .lb-breadcrumb--link:nth-child(2) {
  cursor: default;
}
.search-term {
  max-width: 215px;
  margin-bottom: 15px;
}

.filter-acronym {
  margin-bottom: 18px;
  min-width: 172px;
  max-width: 215px;
  ::v-deep > .pmw-dropdown--trigger-button {
    gap: 5px;
  }
}

.datatable {
  max-height: initial;
  a {
    cursor: pointer;
  }
  ::v-deep {
    .pmw-td span {
      font-size: font-size('size-small');
    }
    .no-gutters > .pmw-col {
      padding-left: 13px;
      padding-right: 13px;
    }

    /** Largura das colunas das ações */
    .pmw-col.pmw-th:nth-child(6),
    .pmw-col.pmw-th:nth-child(7),
    .pmw-col.pmw-td:nth-child(6),
    .pmw-col.pmw-td:nth-child(7) {
      max-width: 76px;
    }

    .pmw-col.pmw-th:nth-child(6) {
      border-right: none;
    }

    .pmw-col.pmw-th:nth-child(6),
    .pmw-col.pmw-th:nth-child(7) {
      pointer-events: none;
      .pmw-icon {
        display: none;
      }
    }
    .links {
      font-size: font-size('size-small');
      font-weight: 500;
      cursor: pointer;
      &--edit {
        color: #466af0;
      }
      &--delete {
        color: #e0414b;
      }
    }
  }
}

.cities {
  .page-actions {
    .heading {
      margin-bottom: 15px;
    }
    &--button {
      width: 100%;

      & + .page-actions--button {
        margin-top: 10px;
      }
    }
  }

  .tips {
    .paragraph {
      line-height: 21px;
    }
  }
}
.link {
  border: none;
  background: inherit;
  color: $primary;
  line-height: 21px;
  padding: 0px;
}
</style>
